import type {SessionItem} from "../session/SessionItem.js";
import {AgentState} from "./AgentState.js";
import {SearchState} from "./SearchState.js";
import type {ChatState} from "./ChatState.js";
import {ref} from "vue";
import type SSEClient from "../SSEComponent/SSEClient.js";
import SSEClient from "../SSEComponent/SSEClient.js";
import {SessionItem} from "../session/SessionItem.js";

export class MessageStateMachine {

    public static STATE_SEARCH = "search"
    public static STATE_AGENT = "agent"
    private nowState: ChatState | null = null
    private nowStateKey: string = ""
    private stateMap: Map<string, ChatState> = new Map()

    private _sseClient: SSEClient
    private _isChatting = ref(false)

    constructor() {

        this.stateMap.set(MessageStateMachine.STATE_SEARCH, new SearchState(this))
        this.stateMap.set(MessageStateMachine.STATE_AGENT, new AgentState())

    }

    public switchState(key: string) {

        if(this.stateMap.has(key)) {

            this.nowState = this.stateMap.get(key) ?? null
            this.nowStateKey = key

        }else {
            console.log("未找到key")
        }

    }

    public getStateKey() {
        return this.nowStateKey
    }

    public async handler(text: string, session: SessionItem) {
        if (this.nowState) {
            await this.nowState.handler(text, session)
        }
    }


    set isChatting(value: boolean) {
        this._isChatting.value = value;
    }

    get isChatting() {
        return this._isChatting
    }


    get sseClient(): SSEClient {
        return this._sseClient;
    }

    set sseClient(value: SSEClient) {
        this._sseClient = value;
    }

    public closeSSE() {
        this._sseClient?.close()
    }

}